import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import ErrorBoundary from './ErrorBoundary';
import '../about.css';

const AboutContent = () => {
  const [aboutData, setAboutData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await fetch('/about/about-content.json');
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setAboutData(data);
      } catch (e) {
        console.error('Error fetching about content:', e);
        setError('Failed to load content. Please try again later.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchContent();
  }, []);

  const authorData = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Blou Bryant",
    "jobTitle": "Author",
    "url": "https://www.bloubryant.com",
    "sameAs": [
      "https://www.facebook.com/profile.php?id=61555668794791"
    ]
  };

  if (isLoading) return <div aria-live="polite" role="status">Loading about content...</div>;
  if (error) return <div aria-live="assertive" role="alert">{error}</div>;

  return (
    <ErrorBoundary>
      <Helmet>
        <title>About Blou Bryant - Author of The Altered Series</title>
        <meta name="description" content="Learn about Blou Bryant, author of The Altered series and other thrilling novels. Discover the writer behind the captivating sci-fi adventures." />
        <script type="application/ld+json">
          {JSON.stringify(authorData)}
        </script>
      </Helmet>
      <article className="about-content bg-soft-white p-6 rounded-lg shadow-md border border-gray-300">
        <h1 className="about-title">About Blou Bryant</h1>
        <div className="marketing-copy">
          <p className="about-intro">{aboutData.intro}</p>
          {aboutData.sections.map((section) => (
            <section key={section.id} id={section.id} className="section">
              <h2 className="section-title">{section.title}</h2>
              {section.content && <p>{section.content}</p>}
              {section.qaPairs && (
                <div className="qa-list">
                  {section.qaPairs.map((qa, index) => (
                    <div key={index}>
                      <p className="question">Q: {qa.question}</p>
                      <p className="answer">A: {qa.answer}</p>
                    </div>
                  ))}
                </div>
              )}
            </section>
          ))}
          <p className="closing-note">{aboutData.closingNote}</p>
        </div>
      </article>
    </ErrorBoundary>
  );
};

export default AboutContent;